import BackToSharkTankAfterLogin from './BackToSharkTankAfterLogin';

export default BackToSharkTankAfterLogin;
